import { Organization } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { StatusEntityConfig } from "./config";
import { StatusFilters } from "./filters";
import { StatusMethods } from "./methods";

const STATUS_TYPE = ["VOLUNTEER", "MISSION", "GROUP"] as const;

export type StatusType = (typeof STATUS_TYPE)[number];

@HyperEntity<Status>("status", StatusEntityConfig)
export class Status extends extender(StatusFilters, StatusMethods) {
  @Fields.id()
  id = "";

  @Fields.string({ dbName: "organization_id" })
  organizationId = "";

  @Relations.toOne(() => Organization, { field: "organizationId" })
  organization?: Organization;

  @Fields.string()
  title = "";

  @Fields.literal(() => STATUS_TYPE)
  type: StatusType = "VOLUNTEER";

  @Fields.string()
  color = "#00b4d8";

  @Fields.number()
  order = 0;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
